import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { logoutUser } from '../../../services/authentication/logout/actions';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';

class LogoutButtonComponent extends React.Component {
    render() {
        const { isButton, text, className, logoutUser, location, history } = this.props;

        const callback = new RegExp(PATH.ACCOUNT_PATH).test(location.pathname)
            ? () => history.push(PATH.HOME_PATH)
            : null;

        if (isButton) {
            return (
                <ButtonComponent
                    text={text}
                    color="main"
                    cssClass={className}
                    onClick={() => logoutUser(callback)}
                />
            );
        } else {
            return (
                <span className={className} onClick={() => logoutUser(callback)}>
                    <SvgComponent src={`${STATIC_ROOT}/deconnexion.svg`} width="16" height="17" />
                </span>
            );
        }
    }
}

LogoutButtonComponent.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string
};

export default withRouter(connect(null, { logoutUser })(LogoutButtonComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/logout/LogoutButtonComponent.js